<template>
  <div>
    <ServerMessage />

    <transition name="menu">
      <AppSearch v-if="$route.name !== 'home' && navSearch" />
    </transition>

    <router-view v-slot="{ Component }">
      <transition name="fade" appear>
        <component :is="Component" />
      </transition>
    </router-view>
  </div>
</template>

<script>
import { mapState, mapActions } from 'pinia';

import AppSearch from 'src/components/global/AppSearch.vue';
import { useAppStore } from 'src/stores/app';

export default {
  name: 'App',
  components: {
    AppSearch,
  },
  computed: {
    ...mapState(useAppStore, ['theme', 'navSearch']),
  },
  watch: {
    $route(val) {
      if (val.meta?.theme) {
        this.setTheme(val.meta?.theme);
      }

      this.setNavSearch(false);
    },
    theme(val, oldVal) {
      document.querySelector('body').classList.remove(`theme--${oldVal}`);
      document.querySelector('body').classList.add(`theme--${val}`);
    },
  },
  created() {
    this.init();
  },
  methods: {
    ...mapActions(useAppStore, ['init', 'setTheme', 'setNavSearch']),
  },
};
</script>

<style>
.q-body--prevent-scroll {
  position: unset !important;
}
</style>
